import { Box, MenuItem } from '@mui/material';
import {
  CustomTextField,
  CustomSelect,
  HorizontalForm,
  VerticalForm,
  DialogTitle,
  CustomTextArea,
} from '../../../common';

const AdditionalDataSection = ({
  selectedLegalEntity,
  onInputChange,
  onSelectChange,
  isMobile,
}) => {
  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>
        Datos adicionales
      </DialogTitle>
      {isMobile ? (
        <VerticalForm>
          <CustomSelect
            label="¿Entidad intermedia?"
            name="is_intermediate_entity"
            value={selectedLegalEntity.is_intermediate_entity || '0'}
            onChange={onSelectChange}
            size="medium"
          >
            <MenuItem value="0">No</MenuItem>
            <MenuItem value="1">Sí</MenuItem>
          </CustomSelect>
          <CustomTextField
            label="Persona de contacto"
            name="contact_information"
            value={selectedLegalEntity.contact_information || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextField
            label="Cuota social"
            name="membership_fee"
            type="number"
            value={selectedLegalEntity.membership_fee || ''}
            onChange={onInputChange}
            size="medium"
          />
          <CustomTextArea
            label="Observaciones"
            name="observations"
            value={selectedLegalEntity.observations || ''}
            onChange={onInputChange}
            rows={4}
            placeholder="Ingrese observaciones aquí"
          />
        </VerticalForm>
      ) : (
        <HorizontalForm withBorder={false} sx={{ p: 1 }}>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
            <CustomSelect
              label="¿Entidad intermedia?"
              name="is_intermediate_entity"
              value={selectedLegalEntity.is_intermediate_entity || '0'}
              onChange={onSelectChange}
              size="medium"
            >
              <MenuItem value="0">No</MenuItem>
              <MenuItem value="1">Sí</MenuItem>
            </CustomSelect>
            <CustomTextField
              label="Persona de contacto"
              name="contact_information"
              value={selectedLegalEntity.contact_information || ''}
              onChange={onInputChange}
              size="medium"
            />
          </Box>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, mr: 4 }}>
            <CustomTextField
              label="Cuota social"
              name="membership_fee"
              type="number"
              value={selectedLegalEntity.membership_fee || ''}
              onChange={onInputChange}
              size="medium"
            />
            <CustomTextArea
              label="Observaciones"
              name="observations"
              value={selectedLegalEntity.observations || ''}
              onChange={onInputChange}
              rows={4}
              placeholder="Ingrese observaciones aquí"
            />
          </Box>
        </HorizontalForm>
      )}
    </Box>
  );
};

export default AdditionalDataSection;
